import React from 'react'
import { Link } from 'react-router-dom'
import { Context } from '../context/LoaderContext'
import { getAuthLogout, getCountryFullName } from '../Constant'
import { Modal } from 'react-responsive-modal'
import axios from 'axios'
import Swal from 'sweetalert2'
import Constant from '../Constant?.js'
import { withTranslation } from 'react-i18next'
import Moment from 'react-moment'
// import 'moment/locale/ar'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentTime: new Date(),

      userModel: false,

      oldPassword: '',
      newPassword: '',
      reenterPassword: '',

      // Notification state
      showNotificationDropdown: false,
      unreadCount: 0,
      recentNotifications: [],
      loadingNotifications: false,
    }
    this.notificationDropdownRef = React.createRef()
  }

  componentDidMount() {
    // Get stored language from localStorage or default to 'en'
    const storedLanguage = localStorage.getItem('selectedLanguage') || 'en'
    const { i18n } = this.props

    // Set initial language from localStorage
    if (i18n.language !== storedLanguage) {
      i18n.changeLanguage(storedLanguage)
    }

    this.intervalId = setInterval(() => {
      this.setState({ currentTime: new Date() })
    }, 1000)

    this.loadNotificationCount()

    // Add click listener to close dropdown when clicking outside
    document.addEventListener('mousedown', this.handleClickOutside)

    // Listen for new notification events from WebSocket
    window.addEventListener('new-notification-received', this.handleNewNotificationEvent)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval)
    }
    document.removeEventListener('mousedown', this.handleClickOutside)
    window.removeEventListener('new-notification-received', this.handleNewNotificationEvent)
  }

  toggleLanguage = () => {
    const { i18n } = this.props
    const currentLanguage = i18n.language
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en'

    localStorage.setItem('selectedLanguage', newLanguage)

    i18n.changeLanguage(newLanguage)
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  changePassword = async () => {
    await axios
      .post(
        Constant?.getAPI() + `/auth/change-password`,
        {
          old_password: this.state.oldPassword,
          password: this.state.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: 'Updated !',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })

          this.setState({
            userModel: false,
            oldPassword: '',
            newPassword: '',
            reenterPassword: '',
          })
        } else {
          Swal.fire({
            title: 'Something Went Wrong',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadNotificationCount = async () => {
    try {
      const res = await axios.get(Constant?.getAPI() + `/notification/unread-count`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      if (res?.data?.success) {
        this.setState({ unreadCount: res.data.data.unread_count || 0 })
      }
    } catch (err) {
      // if (err?.response?.status === 401) {
      //   Constant.getAuthLogout()
      // }
    }
  }

  loadRecentNotifications = async () => {
    this.setState({ loadingNotifications: true })
    try {
      const res = await axios.get(Constant?.getAPI() + `/notification/get-all-notifications`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          pageNumber: 0,
          limit: 5,
        },
      })
      if (res?.data?.success) {
        this.setState({
          recentNotifications: res.data.data || [],
          loadingNotifications: false,
        })
      }
    } catch (err) {
      this.setState({ loadingNotifications: false })
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      }
    }
  }

  toggleNotificationDropdown = () => {
    const newState = !this.state.showNotificationDropdown
    this.setState({ showNotificationDropdown: newState })

    if (newState && this.state.recentNotifications.length === 0) {
      this.loadRecentNotifications()
    }
  }

  handleClickOutside = (event) => {
    if (this.notificationDropdownRef.current && !this.notificationDropdownRef.current.contains(event.target)) {
      this.setState({ showNotificationDropdown: false })
    }
  }

  markNotificationAsRead = async (notificationId) => {
    try {
      await axios.put(
        Constant?.getAPI() + `/notification/mark-read`,
        { notification_id: notificationId },
        {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      this.loadNotificationCount()
      this.loadRecentNotifications()
    } catch (err) {
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      }
    }
  }

  handleNewNotificationEvent = () => {
    this.loadNotificationCount()
    this.loadRecentNotifications()
  }

  handleNotificationClick = (notification) => {
    // Close dropdown
    this.setState({ showNotificationDropdown: false })

    // Mark as read if unread
    if (!notification.is_read) {
      this.markNotificationAsRead(notification.id)
    }

    // Redirect based on notification type
    if (notification.reference_type === 'CRUISE' && notification.reference_id) {
      window.location.href = `/#/booking-ordering/${notification.reference_id}`
    } else if (notification.reference_type === 'CHALET' && notification.reference_id) {
      window.location.href = `/#/chalet-booking-details/${notification.reference_id}`
    } else if (notification.reference_type === 'EVENT' && notification.reference_id) {
      window.location.href = `/#/new-evt/${notification.reference_id}`
    } else if (notification.reference_type === 'STORE' && notification.reference_id) {
      window.location.href = `/#/store-bookings-details/${notification.reference_id}`
    } else if (notification.reference_type === 'TRIP' && notification.reference_id) {
      window.location.href = `/#/cruise-trip-booking-details/${notification.reference_id}`
    } else {
      window.location.href = '/#/booking-payments'
    }
  }

  render() {
    const { i18n } = this.props
    const currentLanguage = i18n.language
    let countryName = getCountryFullName(localStorage.getItem('countryShortName') || 'KWT')

    return (
      <nav
        className="navbar header-navbar pcoded-header noprint"
        id="ad-adda"
      >
        <div className="navbar-wrapper">
          <div className="navbar-logo">
            <a
              className="mobile-menu"
              id="mobile-collapse"
            >
              <i className="feather icon-menu"></i>
            </a>
            <Link to="">
              <h3>
                <img
                  className="img-fluid img-100"
                  src="./assets/images/icon2.png"
                  alt="Theme-Logo"
                />
              </h3>
            </Link>
            <a className="mobile-options">
              <i className="feather icon-more-horizontal"></i>
            </a>
          </div>
          <div className="navbar-container">
            <ul className="nav-left">
              <li>
                <span style={{ fontWeight: 'bold' }}>{this.props.t('country')}:</span>
                {this.props.t(countryName)}
              </li>
              <li>
                <span style={{ fontWeight: 'bold' }}>{this.props.t('currentDateAndTime')}: </span>
                <Moment format="YYYY-MM-DD hh:mm:ss A">{this.state.currentTime}</Moment>
              </li>
            </ul>
            <ul className="nav-right">
              {/* {(localStorage.getItem('loged_In_role') == 'store' ||
                localStorage.getItem('loged_In_role') == 'super-admin') && (
                <li style={{ padding: 0 }}>
                  <button
                    className="btn bg-transparent"
                    onClick={() => {
                      this.context.clearNotificationCount()
                      window.location.href = '#/booking-payments'
                    }}
                  >
                    <i
                      style={{ fontWeight: 'bold', position: 'relative', fontSize: '20px' }}
                      className="ti-bell"
                    >
                      {this.context.notificationCount > 0 && (
                        <div
                          style={{
                            position: 'absolute',
                            background: '#f00',
                            borderRadius: '10px',
                            top: '-2px',
                            minHeight: '10px',
                            minWidth: '10px',
                            right: 0,
                            fontSize: '10px',
                            padding: '2px',
                          }}
                        >
                          {this.context.notificationCount}
                        </div>
                      )}
                    </i>
                  </button>
                </li>
              )} */}
              {localStorage.getItem('loged_In_role') == 'super-admin' && (
                <li
                  style={{ padding: 0, position: 'relative' }}
                  ref={this.notificationDropdownRef}
                >
                  <button
                    className="btn bg-transparent"
                    onClick={this.toggleNotificationDropdown}
                  >
                    <i
                      style={{ fontWeight: 'bold', position: 'relative', fontSize: '20px' }}
                      className="ti-bell"
                    >
                      {this.state.unreadCount > 0 && (
                        <div
                          style={{
                            position: 'absolute',
                            background: '#f00',
                            borderRadius: '10px',
                            top: '-5px',
                            minHeight: '18px',
                            minWidth: '18px',
                            right: '-5px',
                            fontSize: '10px',
                            padding: '2px',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontFamily: 'arial',
                            fontWeight: 'bolder',
                          }}
                        >
                          {this.state.unreadCount}
                        </div>
                      )}
                    </i>
                  </button>
                  {this.state.showNotificationDropdown && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        width: '420px',
                        maxHeight: '550px',
                        overflowY: 'auto',
                        backgroundColor: '#fff',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                        borderRadius: '12px',
                        zIndex: 1000,
                        marginTop: '8px',
                        border: '1px solid #e0e0e0',
                      }}
                    >
                      <div
                        style={{
                          padding: '5px 14px',
                          borderBottom: '2px solid #f0f0f0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          backgroundColor: '#fafafa',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                        }}
                      >
                        <h6 style={{ margin: 0, fontWeight: '700', fontSize: '16px', color: '#333' }}>Notifications</h6>
                        <Link
                          to="/notifications"
                          style={{
                            fontSize: '13px',
                            color: '#1976d2',
                            fontWeight: '600',
                            textDecoration: 'none',
                            transition: 'all 0.2s',
                          }}
                          onClick={() => this.setState({ showNotificationDropdown: false })}
                          onMouseEnter={(e) => {
                            e.target.style.textDecoration = 'underline'
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.textDecoration = 'none'
                          }}
                        >
                          View All →
                        </Link>
                      </div>
                      {this.state.loadingNotifications ? (
                        <div style={{ padding: '40px', textAlign: 'center' }}>
                          <i
                            className="icofont icofont-spinner icofont-spin"
                            style={{ fontSize: '24px', color: '#1976d2' }}
                          ></i>
                          <div style={{ marginTop: '12px', color: '#666', fontSize: '13px' }}>Loading...</div>
                        </div>
                      ) : this.state.recentNotifications.length === 0 ? (
                        <div style={{ padding: '40px', textAlign: 'center' }}>
                          <div style={{ fontSize: '48px', marginBottom: '12px' }}>📭</div>
                          <div style={{ color: '#999', fontSize: '14px' }}>No notifications yet</div>
                        </div>
                      ) : (
                        this.state.recentNotifications.map((notification, index) => (
                          <div
                            key={notification.id}
                            style={{
                              padding: '14px',
                              borderBottom:
                                index < this.state.recentNotifications.length - 1 ? '1px solid #ddd' : 'none',
                              backgroundColor: notification.is_read ? '#fff' : '#f0f8ff',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              position: 'relative',
                            }}
                            onClick={() => this.handleNotificationClick(notification)}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = notification.is_read ? '#fafafa' : '#e3f2fd'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = notification.is_read ? '#fff' : '#f0f8ff'
                            }}
                          >
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                              <div
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '10px',
                                  backgroundColor: notification.is_read ? '#e0e0e0' : '#1976d2',
                                  color: '#fff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '18px',
                                  flexShrink: 0,
                                }}
                              >
                                {notification.notification_type === 'EDIT_BOOKING'
                                  ? '📝'
                                  : notification.notification_type === 'PAYMENT'
                                    ? '💳'
                                    : '🔔'}
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    fontWeight: notification.is_read ? '500' : '700',
                                    fontSize: '14px',
                                    marginBottom: '4px',
                                    color: notification.is_read ? '#424242' : '#1976d2',
                                    lineHeight: '1.4',
                                  }}
                                >
                                  {notification.title_en}
                                </div>
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    lineHeight: '1.4',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    marginBottom: '4px',
                                  }}
                                >
                                  {notification.message_en}
                                </div>
                                <div
                                  style={{
                                    fontSize: '11px',
                                    color: '#999',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                  }}
                                >
                                  <i
                                    className="icofont icofont-clock-time"
                                    style={{ fontSize: '10px' }}
                                  ></i>
                                  <Moment
                                    fromNow
                                    style={{
                                      display: 'inline',
                                      lineHeight: '1',
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {notification.created_at}
                                  </Moment>
                                </div>
                              </div>
                              {!notification.is_read && (
                                <div
                                  style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    flexShrink: 0,
                                    marginTop: '4px',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
                                  }}
                                ></div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </li>
              )}
              <li style={{ padding: 0 }}>
                {localStorage.loged_In_role === 'port-admin' && (
                  <div
                    style={{ marginLeft: '20px', cursor: 'pointer', color: 'blue' }}
                    onClick={this.toggleLanguage}
                  >
                    {currentLanguage === 'en' ? 'AR' : 'EN'}
                  </div>
                )}
              </li>
              <li style={{ padding: 0 }}>
                <button
                  className="btn bg-transparent"
                  onClick={() => {
                    this.setState({
                      userModel: true,
                    })
                  }}
                >
                  <i
                    style={{ fontWeight: 'bold', fontSize: 20 }}
                    className="feather icon-user"
                  ></i>
                </button>
              </li>
              <li style={{ padding: 0 }}>
                <button
                  className="btn bg-transparent"
                  onClick={() => getAuthLogout()}
                  datatoggle="tooltip"
                  title="Logout"
                >
                  <i
                    style={{ fontWeight: 'bold' }}
                    className="feather icon-log-out"
                  ></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <Modal
          open={this.state.userModel}
          onClose={() => {
            this.setState({
              userModel: false,
            })
          }}
          center
        >
          <div style={{ width: 800, paddingRight: 40 }}>
            <div className="header">
              <b>User Details</b>
            </div>
            <div className="body m-t-20">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <label className="col-3">Name</label>
                    <div className="col-9">{`${localStorage.getItem('ad_name')}`}</div>
                  </div>
                  <div className="row">
                    <label className="col-3">Email</label>
                    <div className="col-9">{`${localStorage.getItem('ad_email')}`}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ borderBottom: '1px solid #ddd', marginBottom: 20, marginTop: 20 }}></div>
            <div className="header">
              <b>Change password</b>
            </div>
            <div className="body m-t-20">
              <div className="row">
                <div className="col-12">
                  <div className="form-group row">
                    <label className="col-3 col-form-label">Old Password</label>
                    <div className="col-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter"
                        value={this.state.oldPassword}
                        name="oldPassword"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group row">
                    <label className="col-3 col-form-label">Enter New Password</label>
                    <div className="col-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter"
                        value={this.state.newPassword}
                        name="newPassword"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group row">
                    <label className="col-3 col-form-label">Reenter New Password</label>
                    <div className="col-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter"
                        value={this.state.reenterPassword}
                        name="reenterPassword"
                        onChange={this.handleChange}
                      />
                      {this.state.newPassword != this.state.reenterPassword && (
                        <span style={{ color: '#f00' }}>New password and Reenter password not same</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="text-right col-6 offset-6">
                  <button
                    onClick={() => this.changePassword()}
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled={
                      this.state.oldPassword == '' ||
                      this.state.newPassword == '' ||
                      this.state.reenterPassword == '' ||
                      this.state.newPassword != this.state.reenterPassword
                    }
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </nav>
    )
  }
}

export default withTranslation()(Header)

Header.contextType = Context
